import React from 'react'
import { func, object, array, string } from 'prop-types'

import Dropzone from 'react-dropzone'


function StreamData (props) {
  const { onDropAccepted, upload, file } = props

  return (
    <div>
      <h1>匯入大門資料</h1>
      <Dropzone {...{ onDropAccepted }}>
        {file ? file.name : '拖放或點擊選擇檔案'}
      </Dropzone>
      <div>
        <button onClick={upload} >Import</button>
      </div>
    </div>
  )
}
StreamData.propTypes = {
  onDropAccepted: func,
  upload: func,
  file: object,
}

export default StreamData



// WEBPACK FOOTER //
// ./src/components/GateRecordImporter/GateRecordImporter.jsx